import type { SVGProps } from 'react';

export const Checkmark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    role="img"
    viewBox="0 0 12 8.6"
    x="0px"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    y="0px"
    {...props}
  >
    <title>{'checkmark'}</title>
    <g>
      <path
        d="M4.9,8.6c-0.2,0-0.4-0.1-0.6-0.2L0.2,4.6C0.1,4.4,0,4.2,0,4c0-0.2,0.1-0.4,0.2-0.6l0.6-0.6
            C1,2.7,1.2,2.6,1.4,2.6c0.2,0,0.4,0.1,0.6,0.2l2.9,2.8l5.2-5.4C10.2,0.1,10.4,0,10.6,0h0c0.2,0,0.4,0.1,0.6,0.2l0.6,0.6
            c0.3,0.3,0.3,0.8,0,1.1L5.4,8.4C5.3,8.5,5.1,8.6,4.9,8.6z"
      />
    </g>
  </svg>
);
